<template>
  <modal
    :show="isModalVisible"
    @close="close"
    class="prompt-modal"
    containerStyle="background:#EFF3F3; padding:0; max-width:440px;overflow:hidden; "
    :class="{ 'fade-out': isClosing, 'animation-complete_': isAnimationComplete }"
    style="transition: all 500ms ease-in"
  >
    <canvas
      id="confetti-canvas"
      style="display: block; z-index: 999999; pointer-events: none; position: absolute; width: 100%; height: 100%"
    ></canvas>
    <div style="padding: 2rem 3.125rem">
      <div class="letter-container">
        <div class="letter-image" :class="{ open: isLetterOpen || isAnimationComplete }">
          <div class="animated-mail" :class="{ out: isLetterOut && !isAnimationComplete }">
            <div class="back-fold"></div>
            <div class="letter">
              <div class="letter-border"></div>
              <div class="letter-title"></div>
              <div class="letter-context"></div>
              <div class="letter-stamp">
                <div class="letter-stamp-inner"></div>
              </div>
            </div>
            <div class="top-fold"></div>
            <div class="body"></div>
            <div class="left-fold"></div>
          </div>
          <div class="letter-shadow" :class="{ out: isLetterOut }"></div>
        </div>
      </div>
      <div class="modal-header flex-column">
        <h2 class="m-0" style="font-size: 1.75rem; line-height: 2.25rem">{{ title }}</h2>
        <p class="m-0 my-2 font-weight-bold" style="width: 95%; font-size: 1rem">
          {{ message || 'Great job! Your referral has been sent' }}
        </p>
      </div>
      <div class="modal-body d-flex pb-0">
        <div>
          <div class="feature-list pb-3 pt-1"></div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0)" @click="close" class="btn btn-primary btn-lg btn-xl">Back to Referral</a>
      </div>
    </div>
  </modal>
</template>
  
  <script>
var maxParticleCount = 100 //set max confetti count
var particleSpeed = 2 //set the particle animation speed
var startConfetti //call to start confetti animation
var stopConfetti //call to stop adding confetti
var toggleConfetti //call to start or stop the confetti animation depending on whether it's already running
var removeConfetti //call to stop the confetti animation and remove all confetti immediately
;(function () {
  startConfetti = startConfettiInner
  stopConfetti = stopConfettiInner
  toggleConfetti = toggleConfettiInner
  removeConfetti = removeConfettiInner
  var colors = [
    'DodgerBlue',
    'OliveDrab',
    'Gold',
    'Pink',
    'SlateBlue',
    'LightBlue',
    'Violet',
    'PaleGreen',
    'SteelBlue',
    'SandyBrown',
    'Chocolate',
    'Crimson',
  ]
  var streamingConfetti = false
  var animationTimer = null
  var particles = []
  var waveAngle = 0
  var loop = false

  function resetParticle(particle, width, height) {
    particle.color = colors[(Math.random() * colors.length) | 0]
    particle.x = Math.random() * width
    particle.y = Math.random() * (height / 3) - height
    particle.diameter = Math.random() * 10 + 5
    particle.tilt = Math.random() * 10 - 10
    particle.tiltAngleIncrement = Math.random() * 0.07 + 0.05
    particle.tiltAngle = 0
    return particle
  }

  function startConfettiInner() {
    var width = window.innerWidth
    var height = window.innerHeight
    window.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 16.6666667)
        }
      )
    })()
    var canvas = document.getElementById('confetti-canvas')
    if (canvas === null) {
      //   canvas = document.createElement('canvas')
      //   canvas.setAttribute('id', 'confetti-canvas')
      //   canvas.setAttribute('style', 'display:block;z-index:999999;pointer-events:none;position:fixed')
      //   document.body.appendChild(canvas)
      //   canvas.width = width
      //   canvas.height = height
      //   window.addEventListener(
      //     'resize',
      //     function () {
      //       canvas.width = window.innerWidth
      //       canvas.height = window.innerHeight
      //     },
      //     true
      //   )
      console.warn('Canvas is null, modal likely closed, surpressing animation')
      return
    } else {
      let br = canvas.getBoundingClientRect()
      width = canvas.width = br.width
      height = canvas.height = br.height
    }
    var context = canvas.getContext('2d')
    while (particles.length < maxParticleCount) particles.push(resetParticle({}, width, height))
    streamingConfetti = true
    if (animationTimer === null) {
      ;(function runAnimation() {
        context.clearRect(0, 0, window.innerWidth, window.innerHeight)
        if (particles.length === 0) animationTimer = null
        else {
          updateParticles()
          drawParticles(context)
          animationTimer = window.requestAnimFrame(runAnimation)
        }
      })()
    }
  }

  function stopConfettiInner() {
    streamingConfetti = false
  }

  function removeConfettiInner() {
    stopConfetti()
    particles = []
  }

  function toggleConfettiInner() {
    if (streamingConfetti) stopConfettiInner()
    else startConfettiInner()
  }

  function drawParticles(context) {
    var particle
    var x
    for (var i = 0; i < particles.length; i++) {
      particle = particles[i]
      context.beginPath()
      context.lineWidth = particle.diameter
      context.strokeStyle = particle.color
      x = particle.x + particle.tilt
      context.moveTo(x + particle.diameter / 2, particle.y)
      context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2)
      context.stroke()
    }
  }

  function updateParticles() {
    var width = window.innerWidth
    var height = window.innerHeight
    var particle
    waveAngle += 0.01
    for (var i = 0; i < particles.length; i++) {
      particle = particles[i]
      if (!streamingConfetti && particle.y < -15) particle.y = height + 100
      else {
        particle.tiltAngle += particle.tiltAngleIncrement
        particle.x += Math.sin(waveAngle)
        particle.y += (Math.cos(waveAngle) + particle.diameter + particleSpeed) * 0.5
        particle.tilt = Math.sin(particle.tiltAngle) * 15
      }
      if (particle.x > width + 20 || particle.x < -20 || particle.y > height) {
        if (loop && streamingConfetti && particles.length <= maxParticleCount) resetParticle(particle, width, height)
        else {
          particles.splice(i, 1)
          i--
        }
      }
    }
  }
})()

import Modal from '@/components/Modal'
export default {
  props: ['message'],
  components: { Modal },
  data() {
    return {
      isModalVisible: true,
      isLetterOpen: true,
      isLetterOut: false,
      isClosing: false,
      isAnimationComplete: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLetterOpen = false
      setTimeout(() => {
        startConfetti()
        this.isLetterOut = true
        setTimeout(() => {
          //   this.isClosing = true
          this.isAnimationComplete = true
        }, 1000)
      }, 1000)
    }, 500)
  },
  methods: {
    close() {
      this.isClosing = true
      setTimeout(() => this.$emit('close'), 500)
    },
  },
  computed: {
    maxShowDoctors() {
      return this.maxDoctors || 3
    },
    title() {
      const items = ['And just like that...', 'Just like magic...', 'Delivered!']
      return items[Math.floor(Math.random() * items.length)]
    },
  },
}
</script>
  
  <style lang="scss">
$letter-color: #407d69;
.fade-out {
  opacity: 0;
}
.letter-container {
  position: relative;
  height: 200px;
  margin-bottom: 50px;
  transition: all 1s ease-in;
}
.animation-complete .letter-container {
  height: 0;
  margin-bottom: 0;
}
.letter-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.animated-mail {
  position: absolute;
  height: 150px;
  width: 200px;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  transition: 0.4s;

  .body {
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 100px 200px;
    border-color: transparent transparent lighten($letter-color, 20%) transparent;
    z-index: 2;
  }

  .top-fold {
    position: absolute;
    top: 50px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 50px 100px 0 100px;
    -webkit-transform-origin: 50% 0%;
    -webkit-transition: transform 0.4s 0.4s, z-index 0.2s 0.4s;
    -moz-transform-origin: 50% 0%;
    -moz-transition: transform 0.4s 0.4s, z-index 0.2s 0.4s;
    transform-origin: 50% 0%;
    transition: transform 0.4s 0.4s, z-index 0.2s 0.4s;
    border-color: $letter-color transparent transparent transparent;
    z-index: 2;
  }

  .back-fold {
    position: absolute;
    bottom: 0;
    width: 200px;
    height: 100px;
    background: $letter-color;
    z-index: 0;
  }

  .left-fold {
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 50px 0 50px 100px;
    border-color: transparent transparent transparent lighten($letter-color, 10%);
    z-index: 2;
  }

  .letter {
    left: 20px;
    bottom: 0px;
    position: absolute;
    width: 160px;
    height: 60px;
    background: white;
    z-index: 1;
    overflow: hidden;
    -webkit-transition: 0.4s 0.2s;
    -moz-transition: 0.4s 0.2s;
    transition: 0.4s 0.2s;

    .letter-border {
      height: 10px;
      width: 100%;
      background: repeating-linear-gradient(
        -45deg,
        lighten($letter-color, 15%),
        lighten($letter-color, 15%) 8px,
        transparent 8px,
        transparent 18px
      );
    }

    .letter-title {
      margin-top: 10px;
      margin-left: 5px;
      height: 10px;
      width: 40%;
      background: lighten($letter-color, 15%);
    }
    .letter-context {
      margin-top: 10px;
      margin-left: 5px;
      height: 10px;
      width: 20%;
      background: lighten($letter-color, 15%);
    }

    .letter-stamp {
      margin-top: 30px;
      margin-left: 120px;
      border-radius: 100%;
      height: 30px;
      width: 30px;
      background: lighten($letter-color, 15%);
      opacity: 0.3;
    }
  }
}

.letter-shadow {
  position: absolute;
  top: 200px;
  left: 50%;
  width: 400px;
  height: 30px;
  transition: 0.4s;
  transform: translateX(-50%);
  -webkit-transition: 0.4s;
  -webkit-transform: translateX(-50%);
  -moz-transition: 0.4s;
  -moz-transform: translateX(-50%);

  border-radius: 100%;
  background: radial-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

// .letter-image:hover,
.letter-image.open {
  .animated-mail {
    transform: translateY(50px);
    -webkit-transform: translateY(50px);
    -moz-transform: translateY(50px);
  }

  .animated-mail .top-fold {
    transition: transform 0.4s, z-index 0.2s;
    transform: rotateX(180deg);
    -webkit-transition: transform 0.4s, z-index 0.2s;
    -webkit-transform: rotateX(180deg);
    -moz-transition: transform 0.4s, z-index 0.2s;
    -moz-transform: rotateX(180deg);
    z-index: 0;
  }

  .animated-mail .letter {
    height: 180px;
  }

  .letter-shadow {
    width: 250px;
  }
}

@keyframes fly {
  0% {
    transform: translate(0, 110vh);
    opacity: 0.5;
  }
  50% {
    transform: translate(110vw, 0);
    opacity: 1;
  }
  100% {
    transform: translate(0, 110vh);
    opacity: 0.5;
  }
}

.animated-mail.out,
.letter-shadow.out {
  -webkit-animation-name: magic;
  animation-name: magic;
  -webkit-animation-duration: 1.5s;
  animation-duration: 1.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.letter-shadow.out {
  -webkit-animation-name: shrink;
  animation-name: shrink;
}

@-webkit-keyframes magic {
  0% {
    opacity: 1;
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
    -webkit-transform: scale(1, 1) rotate(0deg);
    transform: scale(1, 1) rotate(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform-origin: 55% 0%;
    transform-origin: 55% 0%;
    -webkit-transform: scale(0, 0) rotate(270deg);
    transform: scale(0, 0) rotate(270deg);
  }
}

@keyframes magic {
  0% {
    opacity: 1;
    -webkit-transform-origin: 100% 55%;
    transform-origin: 100% 55%;
    -webkit-transform: scale(1, 1) rotate(0deg);
    transform: scale(1, 1) rotate(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform-origin: 55% 0%;
    transform-origin: 55% 0%;
    -webkit-transform: scale(0, 0) rotate(270deg);
    transform: scale(0, 0) rotate(270deg);
  }
}

@keyframes shrink {
  0% {
    opacity: 1;
    transform: scale(1, 1) rotate(0deg);
  }
  50% {
    opacity: 0.2;
    transform-origin: left;
    transform: scale(0.1, 0.2) rotate(3deg);
  }
  100% {
    opacity: 0;
    transform-origin: left;
    transform: scale(0) rotate(5deg);
  }
}
</style>